import React, {useEffect, useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import Lottie from 'react-lottie';
import HeadLineComponent from './HeadLineComponent';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import ErrorComponent from './ErrorComponent';
import ApprovedAnimation from '../../../animations/approved-checked-outline.json';
import {gaReportShownPage, gaReportOnButtonClick, gaSuccessPrivate} from './gaReports';
import TVNotification from './tvNotification';
import DebtNotification from './debtNotification';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers';
import ThemedLottie from '../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../utilities/theme/ThemeColorEnum';
const CompletedComponent = ({props, backToLobby}) => {
  if (props.data.currentStep !== 6) {
    return null;
  }

  const goToDebtPayment = () => {
    prepareUrl(`${props.cmsData?.debtPaymentLink?.value?.url}`, props.context);
  };
  const validCC = !props.data.isBusinessBlock && props.privateUserUpdateResultObj ? props.privateUserUpdateResultObj.validCC : true;
  const banListResults = (!props.data.isBusinessBlock && props.privateUserUpdateResultObj?.banList) || [];
  const allUpdatesAreValid = banListResults?.every((res) => res?.updated === true);
  const allUpdatesFailed = banListResults?.every((res) => res?.updated === false);
  const failedUpdates = banListResults?.some((res) => res?.updated === false);
  const accountWithDebt = !props.data.isBusinessBlock ? checkIfHasDept() : false;

  function checkIfHasDept() {
    if (props.data?.accountHasDebt && props.data?.privateUserUpdateResultObj?.banList?.some((ban) => ban.hasDebt == true)) return true;
    return false;
  }
  const [animateOut, setAnimateOut] = useState(false);
  const mainTest =
    props.data.newSelectedPaymentMethod == 'Bank' ? '<p>הבקשה התקבלה, <br/> עכשיו תורנו </p>' : '<p>מעולה, <br/> קיבלנו את הבקשה!</p>';

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    if (props.data.isBusinessBlock) {
      gaReportShownPage('completed');
    }

    setTimeout(() => {
      props.setProgressBarPercent(100);
    }, props.data.animationTimeOut);
  }, []);

  const gaAndBackToBusinessLobby = () => {
    gaReportOnButtonClick('completed_page_back_to_business_lobby_btn');

    backToLobby();
  };

  function renderUpdateStatusTxt() {
    if (props.data.newSelectedPaymentMethod == 'Bank' && props.data.isBusinessBlock) {
      return (
        <p className='mb-0'>
          קיבלנו את הבקשה לעדכון אמצעי התשלום.
          <br /> הטיפול בה ייקח עד 2 ימי עסקים וכשנסיים נשלח מייל עדכון
        </p>
      );
    }
    if (props.data.newSelectedPaymentMethod != 'Bank' && props.data.isBusinessBlock) {
      return (
        <p>
          העדכון יקח כמה דקות וכשנסיים,
          <br />
          נשלח מייל אישור
        </p>
      );
    }
    if (!props.data.isBusinessBlock) {
      if (allUpdatesAreValid) {
        gaSuccessPrivate();
        return <p>העדכון יכנס לתוקף באופן מיידי</p>;
      }
      return <p>יש כאן בעיה</p>;
    }
  }

  return (
    <div className={`${animateOut ? 'animateOut' : 'animateIn'}`}>
      {!props.data.error && validCC === true ? (
        <>
          {!props.data.isBusinessBlock && allUpdatesAreValid ? <HeadLineComponent text={'מעולה'} /> : <HeadLineComponent text={mainTest} />}
          <div className='text-center last-step'>
            <Row>
              <Col xs={12} className='m-auto'>
                {renderUpdateStatusTxt()}
              </Col>
            </Row>
            <Row>
              <Col className='approved-animation'>
                {/* <Lottie options={{animationData: ApprovedAnimation, loop: false}} width={150} height={150} /> */}
                <ThemedLottie animationData={ApprovedAnimation} color={ThemeColorEnum.PRIMARY} width={150} height={150} loop={false} />
              </Col>
            </Row>
            {!props.data.isBusinessBlock && props.privateUserUpdateResultObj.tvUpdated && (
              <Row className='justify-content-md-center'>
                <Col xs={12} className='m-auto'>
                  <TVNotification />
                </Col>
              </Row>
            )}
            {!props.data.isBusinessBlock && props.privateUserUpdateResultObj.debtRedirect && (
              <Row className='justify-content-md-center'>
                <Col xs={12} className='m-auto'>
                  <DebtNotification debtPaymentMethod={goToDebtPayment} />
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12} className='btn-row btn-290'>
                <BtnSubmit
                  isBusiness={props.data.isBusinessBlock}
                  text='אוקיי'
                  onclick={() => {
                    gaAndBackToBusinessLobby();
                  }}
                />
              </Col>
            </Row>
          </div>
        </>
      ) : (
        <ErrorComponent
          failedUpdates={failedUpdates}
          allUpdatesFailed={allUpdatesFailed}
          banListResults={banListResults}
          backToLobby={backToLobby}
          props={props}
          accountWithDebt={accountWithDebt}
        />
      )}
    </div>
  );
};

export default CompletedComponent;
